var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypeHtmlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.804 54.402L7.31 4H56.69L52.19 54.394L31.97 60L11.804 54.402Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55.716L48.34 51.186L52.184 8.12195H32V55.716Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.814H23.82L23.256 20.484H32V14.302H31.978H16.5L16.648 15.962L18.166 32.996H32V26.814Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42.868L31.972 42.876L25.088 41.018L24.648 36.088H21.302H18.442L19.308 45.792L31.972 49.308L32 49.3V42.868Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.978 26.814V32.996H39.59L38.874 41.014L31.978 42.874V49.306L44.652 45.792L44.744 44.748L46.196 28.474L46.348 26.814H44.682H31.978Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.978 14.302V18.142V20.47V20.484H46.89H46.91L47.034 19.096L47.316 15.962L47.464 14.302H31.978Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeHtmlIcon);
export default __webpack_public_path__ + "static/media/file_type_html_icon.67da8eeee4be5be1ff1d93f723bf2e17.svg";
export { ForwardRef as ReactComponent };